import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClientaddressesService } from '../../../../services/apiclient/clientaddresses/clientaddresses.service';
import { ToolsService } from '../../../../services/tools/tools.service';
import { MyStripeService } from '../../../../services/apiclient/myStripe/my-stripe.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-deleteaddress',
  templateUrl: './deleteaddress.component.html',
  styleUrls: ['./deleteaddress.component.css']
})
export class DeleteaddressComponent implements OnInit {

  innerHeight: number = window.innerHeight;

  from: string;

  card: any;
  currCard: any;
  cards: any[] | any;

  index: number | any;

  addressId: any;

  loader: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<DeleteaddressComponent>,
    private apiAddress: ClientaddressesService,
    private tools: ToolsService,
    private apiStripe: MyStripeService,
    public translate: TranslateService
  ) {

    if (data.addressId) { this.addressId = data.addressId; }
    if (data.card) { this.card = data.card; }
    if (data.cards) { this.cards = data.cards; }
    if (data.index) { this.index = data.index; }
    if (data.currCard) { this.currCard = data.currCard; }

    this.from = data.from;

  }

  ngOnInit() {
  }

  closeDial(): void {
    this.dialogRef.close();
  }

  deleteWhat(): void {
  
    this.loader = true;
  
    this.from === 'pms'||this.from === "card"  ? this.deletePaymentMethodStripe()  : this.deleteAddress();


  }

  deleteAddress(): void {

    this.apiAddress.deleteAddress(this.addressId, this.from).subscribe(

      data => {

        if (data.code === 0) {
          this.loader = false;
          this.dialogRef.close(data.addresses);
         
          this.tools.openSnackBar( this.translate.instant('deleteAdressComponent.deleteAdress'), "great");
        }

      }

    )

  }

  deleteCard(): void {


    if (this.card.momentary) {

      this.cards.splice(this.index, 1);

      if (this.card === this.currCard) {
        this.apiStripe.removeCurrCard();
      }

      this.apiStripe.setDefaultCard(this.cards);
      this.dialogRef.close(this.cards);

    } else {

      this.apiStripe.deleteCard(this.card).subscribe(

        data => {

          if (data.code === 0) {

            this.loader = false;
            this.dialogRef.close(data.cards);
            this.tools.openSnackBar( this.translate.instant('deleteAdressComponent.deleteCard'), "great");

          }

        }

      );

    }

  }


  deletePaymentMethodStripe(): void {
 

    this.apiStripe.deletePaymentMethod(this.card).subscribe(

      data => {
      
        if (data.code === 0) {
          

          this.loader = false;

          //on set le default paiement

          this.dialogRef.close(data.paymentMethods);
          this.tools.openSnackBar(this.translate.instant('deleteAdressComponent.methodPayDeleted'), "great");

        }
        else {
          if (data.err || data.error) {
            this.loader = false;
            this.dialogRef.close();
            this.tools.openSnackBar(data.message, "warn");

          }
        }

      }

    );

  }



}
